export default __webpack_public_path__ + "static/media/serviciosAlarma1.d293650a.png";